import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TitleContainerComponent } from '@shared/components/title-container.component';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AllAssessmentStore } from '../stores/all-assessments.store';
import { AssessmentsApiService } from '../services/assessments-api.service';
import { DividerComponent } from '@shared/components/divider.component';
import { AllAssessmentsTableComponent } from './all-assessments-table/all-assessments-table.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AllAssessmentsFilterComponent } from './all-assessments-filter/all-assessments-filter.component';
import { SensitivityLevelApiService } from '../services/sensitivity-level-api.service';
import { MainDriverApiService } from '../services/main-driver-api.service';
import { UserApiService } from '../services/user-api.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { getDateRangeInMonths } from '@shared/utils/date.utils';

@Component({
  selector: 'app-all-assessments',
  imports: [
    TitleContainerComponent,
    MatButtonModule,
    MatIconModule,
    DividerComponent,
    AllAssessmentsTableComponent,
    MatProgressBarModule,
    AllAssessmentsFilterComponent,
    MatProgressSpinnerModule,
    MatTooltip,
  ],
  templateUrl: './all-assessments.component.html',
  styleUrl: './all-assessments.component.scss',
  providers: [AllAssessmentStore, AssessmentsApiService, SensitivityLevelApiService, MainDriverApiService, UserApiService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllAssessmentsComponent {
  readonly router = inject(Router);
  readonly store = inject(AllAssessmentStore);
  isLoading = this.store.isLoading;
  isLoadingExport = this.store.isLoadingExport;

  hasInvalidExportFilters = computed(() => {
    const isMyScope = this.store.myScope();
    if (isMyScope) return false;

    const selectedFilters = this.store.selectedDialogFilter();
    const filterByDateFrom = selectedFilters.dateFrom;
    if (!filterByDateFrom) return true;

    const filterByDateTo = selectedFilters.dateTo ?? new Date();
    const dateRangeInMonths = getDateRangeInMonths(filterByDateFrom, filterByDateTo);
    return dateRangeInMonths > 13;
  });

  addNewAssessment() {
    this.router.navigate(['/assessments/new']);
  }

  exportExcel() {
    this.store.exportExcel();
  }
}
